import React, { createRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

export const alertModalRef = createRef();

export const showAlert = (
  title,
  text,
  callback = () => {},
  alternativeButtonText,
  alternativeButtonCallback,
) => {
  alertModalRef.current?.show(
    title,
    text,
    callback,
    alternativeButtonText,
    alternativeButtonCallback,
  );
};

class AlertModel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      text: '',
      alternativeButtonText: '',
      show: false,
    };

    this.callback = () => {};
    this.alternativeButtonCallback = () => {};
  }

  componentDidMount() {
    alertModalRef.current = this;
    this.props.onRef && this.props.onRef(this);
  }

  componentWillUnmount() {
    if (alertModalRef.current === this) {
      alertModalRef.current = null;
    }
  }

  show = (
    title,
    text,
    callback,
    alternativeButtonText,
    alternativeButtonCallback,
  ) => {
    this.setState({
      show: true,
      title: title,
      text: text,
      alternativeButtonText,
    });
    this.callback = callback || (() => {});
    this.alternativeButtonCallback = alternativeButtonCallback;
  };

  render() {
    const { t } = this.props;
    return (
      <Modal
        id='modal_alert'
        centered
        show={this.state.show}
        onHide={() => this.setState({ show: false })}>
        <Modal.Header closeButton>
          <Modal.Title>{this.state.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.state.text}</Modal.Body>
        <Modal.Footer>
          {this.state.alternativeButtonText ? (
            <Button
              style={{ marginRight: 10 }}
              variant='outline-primary'
              onClick={this.alternativeButtonCallback}>
              {this.state.alternativeButtonText}
            </Button>
          ) : null}
          <Button
            id='button_ok'
            variant='primary'
            onClick={() => {
              this.setState({ show: false });
              this.callback();
            }}>
            {t(`global.ok`)}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default withTranslation()(AlertModel);
